import {validateValue} from '../helpers/validation'

// Begin action types
export const CLEAR_VACANCY = 'CLEAR_VACANCY'

export const FETCH_VACANCY_OVERVIEW_SUCCESS = 'FETCH_VACANCY_OVERVIEW_SUCCESS'

export const CLEAR_VACANCY_CANDIDATES = 'CLEAR_VACANCY_CANDIDATES'
export const FETCH_VACANCY_CANDIDATES_SUCCESS = 'FETCH_VACANCY_CANDIDATES_SUCCESS'
export const CLEAR_VACANCY_CANDIDATE_SEARCH_FIELDS = 'CLEAR_VACANCY_CANDIDATE_SEARCH_FIELDS'
export const VALIDATE_VACANCY_CANDIDATE_SEARCH_FIELD = 'VALIDATE_VACANCY_CANDIDATE_SEARCH_FIELD'

export const CLEAR_VACANCY_CONTRACTS = 'CLEAR_VACANCY_CONTRACTS'
export const FETCH_VACANCY_CONTRACTS_SUCCESS = 'FETCH_VACANCY_CONTRACTS_SUCCESS'

export const SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS = 'SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS'
export const SET_VACANCY_CRITERIA_CHECKBOX_VALUE = 'SET_VACANCY_CRITERIA_CHECKBOX_VALUE'
export const VALIDATE_VACANCY_CRITERIA_DIRECTOR_FIELD = 'VALIDATE_VACANCY_CRITERIA_DIRECTOR_FIELD'
export const CLEAR_VACANCY_CRITERIA_DIRECTOR_FIELDS = 'CLEAR_VACANCY_CRITERIA_DIRECTOR_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_TRANSLATOR_FIELD = 'VALIDATE_VACANCY_CRITERIA_TRANSLATOR_FIELD'
export const CLEAR_VACANCY_CRITERIA_TRANSLATOR_FIELDS = 'CLEAR_VACANCY_CRITERIA_TRANSLATOR_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD = 'VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD'
export const CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS = 'CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_SINGER_FIELD = 'VALIDATE_VACANCY_CRITERIA_SINGER_FIELD'
export const CLEAR_VACANCY_CRITERIA_SINGER_FIELDS = 'CLEAR_VACANCY_CRITERIA_SINGER_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_ADAPTOR_FIELD = 'VALIDATE_VACANCY_CRITERIA_ADAPTOR_FIELD'
export const CLEAR_VACANCY_CRITERIA_ADAPTOR_FIELDS = 'CLEAR_VACANCY_CRITERIA_ADAPTOR_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_LYRICIST_FIELD = 'VALIDATE_VACANCY_CRITERIA_LYRICIST_FIELD'
export const CLEAR_VACANCY_CRITERIA_LYRICIST_FIELDS = 'CLEAR_VACANCY_CRITERIA_LYRICIST_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_EDITOR_FIELD = 'VALIDATE_VACANCY_CRITERIA_EDITOR_FIELD'
export const CLEAR_VACANCY_CRITERIA_EDITOR_FIELDS = 'CLEAR_VACANCY_CRITERIA_EDITOR_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_SOUNDENGINEER_FIELD = 'VALIDATE_VACANCY_CRITERIA_SOUNDENGINEER_FIELD'
export const CLEAR_VACANCY_CRITERIA_SOUNDENGINEER_FIELDS = 'CLEAR_VACANCY_CRITERIA_SOUNDENGINEER_FIELDS'
export const VALIDATE_VACANCY_CRITERIA_BOOKER_FIELD = 'VALIDATE_VACANCY_CRITERIA_BOOKER_FIELD'
export const CLEAR_VACANCY_CRITERIA_BOOKER_FIELDS = 'CLEAR_VACANCY_CRITERIA_BOOKER_FIELDS'
export const FETCH_VACANCY_SKILLVENDORS_BY_CRITERIA_SUCCESS = 'FETCH_VACANCY_SKILLVENDORS_BY_CRITERIA_SUCCESS'
export const CLEAR_VACANCY_SKILLVENDORS_BY_CRITERIA = 'CLEAR_VACANCY_SKILLVENDORS_BY_CRITERIA'

export const FETCH_VACANCY_ACTIVATE_DATA_SUCCESS = 'FETCH_VACANCY_ACTIVATE_DATA_SUCCESS'
export const VALIDATE_VACANCY_ACTIVATE_FIELD = 'VALIDATE_VACANCY_ACTIVATE_FIELD'
export const VALIDATE_VACANCY_ACTIVATE_WORK_AMOUNT_UNIT_FIELD = 'VALIDATE_VACANCY_ACTIVATE_WORK_AMOUNT_UNIT_FIELD'
export const TAKE_FIRST_STANDARD_RATE_ON_VACANCY_ACTIVATE = 'TAKE_FIRST_STANDARD_RATE_ON_VACANCY_ACTIVATE'
export const SUBMIT_VACANCY_ACTIVATE_FIELDS = 'SUBMIT_VACANCY_ACTIVATE_FIELDS'
export const CLEAR_VACANCY_ACTIVATE_FIELDS = 'CLEAR_VACANCY_ACTIVATE_FIELDS'
export const CLEAR_VACANCY_ACTIVATE_FIELD = 'CLEAR_VACANCY_ACTIVATE_FIELD'
// End action types

export const clearVacancy = () => ({
  type: CLEAR_VACANCY
});

export const fetchVacancyOverviewSuccess = (overview) => ({
  type: FETCH_VACANCY_OVERVIEW_SUCCESS,
  overview
});

export const clearVacancyCandidates = () => ({
  type: CLEAR_VACANCY_CANDIDATES
});
export const fetchVacancyCandidatesSuccess = (candidates) => ({
  type: FETCH_VACANCY_CANDIDATES_SUCCESS,
  candidates
});
export const clearVacancyCandidateSearchFields = () => ({
  type: CLEAR_VACANCY_CANDIDATE_SEARCH_FIELDS
});
export const validateVacancyCandidateSearchField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CANDIDATE_SEARCH_FIELD,
    field
  }
}

export const clearVacancyContracts = () => ({
  type: CLEAR_VACANCY_CONTRACTS
});

export const fetchVacancyContractsSuccess = (contracts) => ({
  type: FETCH_VACANCY_CONTRACTS_SUCCESS,
  contracts
});

export const setVacancyCriteriaDropdownOptions = (skillLevels, cities, voiceGenders, liveActionVoiceGenders, animationVoiceGenders, nativeLanguages, languages, productionContentOwners,
   ageFromList, ageToList, productionExperienceList, country, region, ethnicity, identity, voiceAgeRangeList, voiceTypeList, remoteRecordingListVoiceActor,
   remoteRecordingDirector, voiceActorStudio, voiceActorClient,voiceActorSchool, skillTypes, productionCast, vacancyCast, externalExperienceCast,
 bookerStudio, voiceAgeRangeListSinger, vocalRangeListSinger, readingMusicNoteListSinger, singerStudio, singerClient, singerSchool,
directorStudio, directorClient, directorSchool, numberOfSongsWrittenRangeListLyricist, universityDegreeListLyricist, lyricistStudio, lyricistClient,
remoteRecordingListLyricist, numberOfTranslationsRangeListTranslator, universityDegreeListTranslator, translatorStudio, translatorClient, editorStudio,
 editorClient, editorSchool, remoteRecordingEditor, numberOfAdaptionsRangeListAdaptor, universityDegreeListAdaptor, adaptorStudio, adaptorClient,
 soundEngineerStudio, soundEngineerClient, soundEngineerSchool, remoteRecordingListSoundEngineer, directorAppAccess, remoteRecordingListSinger,
languageAccentList, unionListVoiceActor, unionListSinger) => ({
  type: SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  skillLevels,
  cities,
  voiceGenders,
  liveActionVoiceGenders,
  animationVoiceGenders,
  nativeLanguages,
  languages,
  productionContentOwners,
  ageFromList,
  ageToList,
  productionExperienceList,
  country,
  region,
  ethnicity,
  identity,
  voiceAgeRangeList,
  voiceTypeList,
  remoteRecordingListVoiceActor,
  remoteRecordingDirector,
  voiceActorStudio,
  voiceActorClient,
  voiceActorSchool,
  skillTypes,
  productionCast,
  vacancyCast,
  externalExperienceCast,
  bookerStudio,
  voiceAgeRangeListSinger,
  vocalRangeListSinger,
  readingMusicNoteListSinger,
  singerStudio,
  singerClient,
  singerSchool,
  directorStudio,
  directorClient,
  directorSchool,
  numberOfSongsWrittenRangeListLyricist,
  universityDegreeListLyricist,
  lyricistStudio,
  lyricistClient,
  remoteRecordingListLyricist,
  numberOfTranslationsRangeListTranslator,
  universityDegreeListTranslator,
  translatorStudio,
  translatorClient,
  editorStudio,
  editorClient,
  editorSchool,
  remoteRecordingEditor,
  numberOfAdaptionsRangeListAdaptor,
  universityDegreeListAdaptor,
  adaptorStudio,
  adaptorClient,
  soundEngineerStudio,
  soundEngineerClient,
  soundEngineerSchool,
  remoteRecordingListSoundEngineer,
  directorAppAccess,
  remoteRecordingListSinger,
  languageAccentList,
  unionListVoiceActor,
  unionListSinger
});
export const setVacancyCriteriaCheckboxValue = (knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale,liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
voiceActorTVExperience,voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience,voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience,voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender,singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience,  directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience, soundEngineerDubbingExperience, soundEngineerVoiceOverExperience, soundEngineerSongsExperience,
soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,soundEngineerDialogueRecordingExperience,
soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,soundEngineerAudioDescriptionMixingExperience,
singerGenderNeutralVoice, voiceActorGenderNeutralVoice,adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse ) => ({
  type: SET_VACANCY_CRITERIA_CHECKBOX_VALUE,
  knownTalent,
  doNotUse,
  skillVendorStatus,
  liveActionVoiceGenderMale,
  liveActionVoiceGenderFemale,
  voiceActorTheatricalExperience,
  voiceActorTVExperience,
  voiceActorVideoGamesExperience,
  voiceActorPromoOrCommercialsExperience,
  voiceActorAnimationMaleVoiceGender,
  voiceActorAnimationFemaleVoiceGender,
  voiceActorLiveActionExperience,
  voiceActorAnimationExperience,
  voiceActorDubbingExperience,
  voiceActorAudiobooksExperience,
  voiceActorVoiceOverExperience,
  voiceActorRadioExperience,
  voiceActorTheatreActorExperience,
  voiceActorMovieActorExperience,
  voiceActorAudioDescriptionExperience,
  bookerTheatricalExperience,
  bookerTVExperience,
  bookerInteractiveExperience,
  singerMaleVoiceGender,
  singerFemaleVoiceGender,
  singerDubbingExperience,
  singerStageExperience,
  singerTheatreExperience,
  singerTalentShowExperience,
  directorTheatricalExperience,
  directorTVExperience,
  directorGamesExperience,
  directorPromoOrCommercialsExperience,
  directorLiveActionExperience,
  directorAnimationExperience,
  directorDubbingDirectorExperience,
  directorVoiceOverDirectorExperience,
  directorSongDirectorExperience,
  directorDubbingActorExperience,
  directorStageDirectorExperience,
  directorMovieDirectorExperience,
  directorAudioDescriptionExperience,
  lyricistMusicalExperience,
  lyricistTheatreExperience,
  lyricistPromoCommercialsExperience,
  lyricistExperience,
  lyricistDubbingExperience,
  lyricistMusicianExperience,
  translatorTheatricalExperience,
  translatorTVExperience,
  translatorGamesExperience,
  translatorPromoOrCommercialsExperience,
  translatorLiveActionExperience,
  translatorAnimationExperience,
  translatorSubtitlesExperience,
  translatorDubbingExperience,
  translatorVoiceOverExperience,
  translatorGamingExperience,
  translatorAudioDescriptionExperience,
  translatorHOHSDHCCExperience,
  editorDubbingExperience,
  editorVoiceOverExperience,
  editorSongsExperience,
  editorProToolsExperience,
  editorDolby51Experience,
  editorAtmosExperience,
  editorFoleyExperience,
  editorRecordingEditingExperience,
  editorDialogueEditingExperience,
  editorMusicAndEffectsExperience,
  editorMixEditingExperience,
  editorPreparingTakesExperience,
  editorAudioDescriptionExperience,
  adaptorTheatricalExperience,
  adaptorTVExperience,
  adaptorGamesExperience,
  adaptorPromoOrCommercialsExperience,
  adaptorLiveActionExperience,
  adaptorAnimationExperience,
  adaptorAdaptorExperience,
  adaptorDubbingDirectorExperience,
  adaptorTranslatorExperience,
  adaptorVoiceActorExperience,
  adaptorAudioDescriptionExperience,
  soundEngineerDubbingExperience,
  soundEngineerVoiceOverExperience,
  soundEngineerSongsExperience,
  soundEngineerProToolsExperience,
  soundEngineerDolby51Experience,
  soundEngineerAtmosExperience,
  soundEngineerFoleyExperience,
  soundEngineerDialogueRecordingExperience,
  soundEngineerSongRecordingExperience,
  soundEngineerDialogueMixingExperience,
  soundEngineerSongMixingExperience,
  soundEngineerAudioDescriptionMixingExperience,
  singerGenderNeutralVoice,
  voiceActorGenderNeutralVoice,
  adaptorDoNotUse,
  bookerDoNotUse,
  directorDoNotUse,
  editorDoNotUse,
  lyricistDoNotUse,
  singerDoNotUse,
  soundEngineerDoNotUse,
  translatorDoNotUse,
  voiceActorDoNotUse
});
export const clearVacancyCriteriaDirectorFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_DIRECTOR_FIELDS
});
export const validateVacancyCriteriaDirectorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_DIRECTOR_FIELD,
    field
  }
}
export const clearVacancyCriteriaTranslatorFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_TRANSLATOR_FIELDS
});
export const validateVacancyCriteriaTranslatorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_TRANSLATOR_FIELD,
    field
  }
}
export const clearVacancyCriteriaVoiceActorFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS
});
export const validateVacancyCriteriaVoiceActorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD,
    field
  }
}
export const clearVacancyCriteriaSingerFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_SINGER_FIELDS
});
export const validateVacancyCriteriaSingerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_SINGER_FIELD,
    field
  }
}
export const clearVacancyCriteriaAdaptorFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_ADAPTOR_FIELDS
});
export const validateVacancyCriteriaAdaptorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_ADAPTOR_FIELD,
    field
  }
}
export const clearVacancyCriteriaLyricistFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_LYRICIST_FIELDS
});
export const validateVacancyCriteriaLyricistField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_LYRICIST_FIELD,
    field
  }
}
export const clearVacancyCriteriaEditorFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_EDITOR_FIELDS
});
export const validateVacancyCriteriaEditorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_EDITOR_FIELD,
    field
  }
}
export const clearVacancyCriteriaSoundEngineerFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_SOUNDENGINEER_FIELDS
});
export const validateVacancyCriteriaSoundEngineerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_SOUNDENGINEER_FIELD,
    field
  }
}
export const clearVacancyCriteriaBookerFields = () => ({
  type: CLEAR_VACANCY_CRITERIA_BOOKER_FIELDS
});
export const validateVacancyCriteriaBookerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_CRITERIA_BOOKER_FIELD,
    field
  }
}
export const fetchVacancySkillVendorsByCriteriaSuccess = (skillVendorsByCriteria) => ({
  type: FETCH_VACANCY_SKILLVENDORS_BY_CRITERIA_SUCCESS,
  skillVendorsByCriteria
});
export const clearVacancySkillVendorsByCriteria = () => ({
  type: CLEAR_VACANCY_SKILLVENDORS_BY_CRITERIA
});

export const fetchVacancyActivateDataSuccess = (data, descriptionRequired) => ({
  type: FETCH_VACANCY_ACTIVATE_DATA_SUCCESS,
  data,
  descriptionRequired
});
export const validateVacancyActivateField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_ACTIVATE_FIELD,
    field
  }
}
export const validateVacancyActivateWorkAmountUnitField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VACANCY_ACTIVATE_WORK_AMOUNT_UNIT_FIELD,
    field
  }
}
export const takeFirstStandardRateOnVacancyActivate = (field) => {
  return {
    type: TAKE_FIRST_STANDARD_RATE_ON_VACANCY_ACTIVATE,
    field
  }
}
export const submitVacancyActivateFields = (fields) => {
  return {
    type: SUBMIT_VACANCY_ACTIVATE_FIELDS,
    fields
  }
}
export const clearVacancyActivateFields = (fields) => {
  return {
    type: CLEAR_VACANCY_ACTIVATE_FIELDS
  }
}
export const clearVacancyActivateField = (fieldName) => {
  return {
    type: CLEAR_VACANCY_ACTIVATE_FIELD,
    fieldName
  }
}
